var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"extra-large":"","title":"inconsistências"},scopedSlots:_vm._u([{key:"footer",fn:function({cancel}){return [_c('rkm-button',{attrs:{"color":"secondary"},on:{"click":cancel}},[_vm._v(" Fechar ")])]}}])},[_c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }